/**
 * messagePriority — degrés d'importance dans la Messagerie (retour apprenant :
 * « messagerie trop basique, ajouter urgent ou non »).
 *
 * Un message est URGENT si :
 *   • il porte explicitement `priority: 'urgent'`, ou
 *   • son ton est `urgent`, ou
 *   • c'est une décision non traitée qui expire dans ≤ 3 jours.
 */
export const URGENT_DECISION_WINDOW_DAYS = 3;

export function getMessagePriority(msg, today = 0) {
  if (!msg) return 'normal';
  if (msg.priority === 'urgent' || msg.priority === 'normal') return msg.priority;
  if (msg.tone === 'urgent') return 'urgent';
  if (msg.kind === 'decision' && !msg.replied && Number.isFinite(msg.expiresDay)
    && (msg.expiresDay - today) <= URGENT_DECISION_WINDOW_DAYS) return 'urgent';
  return 'normal';
}

export const isUrgentMessage = (msg, today = 0) => getMessagePriority(msg, today) === 'urgent';

/** Messages urgents non lus à rappeler (bandeau Dashboard) — les plus récents d'abord. */
export function getPendingUrgentMessages(inbox = [], today = 0, limit = 5) {
  return (inbox || [])
    .filter((m) => !m.read && isUrgentMessage(m, today))
    .sort((a, b) => (b.receivedDay || 0) - (a.receivedDay || 0))
    .slice(0, limit);
}
